import {navigate} from '../actions/navigation'
import {placeOrder, updateOrder} from '../actions/placed-order'
import {makeReservation} from '../actions/reservation'
import {State} from '../types/state'

export const isRequestPending = (state: State, actionType: string) => !!state.pendingRequests.loading[actionType]

export const isCheckoutActionPending = (state: State): boolean => {
  const updateOrderInProgress = isRequestPending(state, updateOrder.typePrefix)

  const placeOrderInProgress = isRequestPending(state, placeOrder.typePrefix)

  const reserveTicketsInProgress = isRequestPending(state, makeReservation.typePrefix)

  const navigateInProgress = isRequestPending(state, navigate.typePrefix)

  return updateOrderInProgress || placeOrderInProgress || reserveTicketsInProgress || navigateInProgress
}
